import { TimeService_timeServiceGetGetTime } from '@festina/collcalc-general-types/collcalc-test/hooks/TimeService_timeServiceGetGetTime'

export const useFetchCollCalcTime = TimeService_timeServiceGetGetTime.useQuery
